// Properly handle server-side rendering.
let win;

if (typeof window !== 'undefined') {
    win = window;
} else if (typeof self !== 'undefined') {
    win = self;
} else {
    win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
const request =
    win.requestAnimationFrame ||
    win.webkitRequestAnimationFrame ||
    win.mozRequestAnimationFrame ||
    win.oRequestAnimationFrame ||
    win.msRequestAnimationFrame ||
    function(callback) {
        return (win).setTimeout(callback, 1000 / 60);
    };

const cancel =
    win.cancelAnimationFrame ||
    win.webkitCancelAnimationFrame ||
    win.mozCancelAnimationFrame ||
    win.oCancelAnimationFrame ||
    win.msCancelAnimationFrame ||
    function(id) {
        (win).clearTimeout(id);
    };

export const cancelAnimationTimeout = (frame) =>
    cancel(frame.id);

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
export const requestAnimationTimeout = (callback, delay) => {
    const start = Date.now();

    const timeout = () => {
        if (Date.now() - start >= delay) {
            callback.call();
        } else {
            frame.id = request(timeout);
        }
    };

    const frame = {
        id: request(timeout)
    };

    return frame;
};
